<template>
  <div class="demo">
    <div class="hero">
      <div class="container" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Demo",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Demo aanvragen",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  background: $white url("../assets/img/man-jumping.jpg");
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: contain;
  padding: 100px 0 30px;
  min-height: 100vh;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
